
import * as _recipes from './data/nms-refinery.json';
import { IMaterial, IMaterialMap } from './Interfaces';

const recipes: IMaterialMap = _recipes;
const ordered: IMaterial[] = Object.keys(recipes).map((x) => recipes[x])
  .sort((a, b) => a.name > b.name ? 1 : -1);
//  .filter((m) => m && m.recipes && m.recipes.length);

export { recipes, ordered };



// WEBPACK FOOTER //
// ./src/Dataset.ts